import { LOADING_INDICATOR_CSS_SELECTOR } from '@vfde-sails/constants';
import {
    DELIVERY_DATE_CONTAINER_ID,
    ERROR_NOTIFICATION_CONTAINER_ID,
    HARDWARE_ONLY_SWITCH_CONTAINER_ID,
    HTML_CONTAINER_ID_PREFIX,
    IMAGE_GALLERY_CONTAINER_ID,
    OFFER_SUMMARY_CARD_CONTAINER_ID,
    OPTION_PICKER_CAPACITY_CONTAINER_ID,
    OPTION_PICKER_COLOR_CONTAINER_ID,
    PROMOS_CONTAINER_ID,
    STICKY_PRICE_BAR_CONTAINER_ID,
    TECHNICAL_DETAILS_ACCORDION_CONTAINER_ID,
    TEXT_HEADER_CONTAINER_ID,
    TRADEIN_PROMO_ICON_TEXT_LIST_CONTAINER_ID,
} from '../../app/constants';
import { initEditorialOverlays } from '@vfde-sails/overlay';
import { useAppDispatch } from '../../app/store';
import { mountEditorialAccordions } from '../../components/Accordion';
import { mountEditorialPromotionalCards } from '../../components/PromotionalCard';
import { prepareTechnicalDetailsAccordion } from './components/AccordionForTechnicalDetails';
import { mountBeltContainers } from './components/BeltContainer';
import { mountDeliveryDateIconText } from './components/IconTextForDeliveryDate';
import { mountPromoOverviewIconTextList } from './components/IconTextListForPromoOverview';
import { prepareImageGallery } from './components/ImageGallery';
import { mountLoadingSpinner } from './components/LoadingSpinner';
import { mountOfferSummaryCard } from './components/OfferSummaryCard';
import { mountCapacityOptionPicker } from './components/OptionPickerForCapacity';
import { mountColorOptionPicker } from './components/OptionPickerForColor';
import { prepareOverlay } from './components/Overlay';
import { mountHardwareOnlySwitch } from './components/SwitchForHardwareOnly';
import { mountTextHeader } from './components/TextHeader';
import { getCustomerConfig } from './helpers/getCustomerConfig';
import { startListeners } from './listeners';
import { setInitialState } from './slice';

/**
 * Init app
 */
export const initApp = () => {
    startListeners();

    const dispatch = useAppDispatch();
    const customerConfig = getCustomerConfig();

    mountLoadingSpinner(LOADING_INDICATOR_CSS_SELECTOR);
    mountBeltContainers(HTML_CONTAINER_ID_PREFIX, ERROR_NOTIFICATION_CONTAINER_ID);
    mountTextHeader(TEXT_HEADER_CONTAINER_ID);
    prepareImageGallery(IMAGE_GALLERY_CONTAINER_ID);
    mountColorOptionPicker(OPTION_PICKER_COLOR_CONTAINER_ID);
    mountCapacityOptionPicker(OPTION_PICKER_CAPACITY_CONTAINER_ID);
    mountDeliveryDateIconText(DELIVERY_DATE_CONTAINER_ID);
    mountHardwareOnlySwitch(HARDWARE_ONLY_SWITCH_CONTAINER_ID, customerConfig.isHardwareOnly);
    mountOfferSummaryCard(OFFER_SUMMARY_CARD_CONTAINER_ID, STICKY_PRICE_BAR_CONTAINER_ID);
    mountPromoOverviewIconTextList(TRADEIN_PROMO_ICON_TEXT_LIST_CONTAINER_ID);
    mountEditorialPromotionalCards(PROMOS_CONTAINER_ID);
    mountEditorialAccordions([TECHNICAL_DETAILS_ACCORDION_CONTAINER_ID]);
    prepareTechnicalDetailsAccordion(TECHNICAL_DETAILS_ACCORDION_CONTAINER_ID);

    prepareOverlay();
    initEditorialOverlays(dispatch);

    dispatch(setInitialState({ customerConfig }));
};
